import React from 'react';
import './Shimmer.css';

const Shimmer: React.FC = () => {
  return (
    <div className='shimmer-wrapper'>
      <div className='shimmer'></div>
    </div>
  );
};

export default Shimmer;
